import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link, useParams } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import { Tooltip, OverlayTrigger, Badge, Button } from "react-bootstrap";
import Drawer from '@mui/material/Drawer';
import DatePicker from "react-multi-date-picker";
import Select from "react-select";
import swal from "sweetalert2";
import idly from '../../../../images/product/break_box.png';
import lunch from '../../../../images/product/meals_box.png';
import dinner from '../../../../images/product/dinner_box.png';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';


import ChangeProductDetails from '../../../modal/Subscription_Management/Manage_Subscriptions/ChangeProductDetails';
// import { useLocation } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { addDays } from 'date-fns';
import { useNavigate } from 'react-router-dom';

const AddSubscription = () => {
    const { ID } = useParams();
    const navigate = useNavigate();
    // const location = useLocation();
    // const { ID } = location.state || {};

    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const user_id = parseInt(localStorage.getItem("user_id"), 10);

    const [lead_name, setname] = useState('');
    const [mobile_no, setMobileno] = useState('');
    const [email_id, setEmailid] = useState('');
    const [address, setAddress] = useState('');
    const [leadId, setLeadID] = useState(null);
    const [area_name, setareaname] = useState('');
    const [area, setarea] = useState(null);
    const [areaID, setAreaID] = useState(null);
    const [gst_percentage, setgst_percentage] = useState(0);

    // product details
    const [person_name, setpersonName] = useState('');
    const [delivery_contact, setdeliverycontact] = useState('');
    const [delivery_address, setdeliveryaddress] = useState('');
    const [delivery_latitude, setdeliveryLatitude] = useState('');
    const [delivery_longitude, setdeliveryLongitude] = useState('');

    useEffect(() => {
        const fetchleaddetails = async () => {
          try {
            const response = await axios.get(`${baseURL}/subscriber/profile/${ID}`);
            setname(response.data.subscriber_name);
            setpersonName(response.data.subscriber_name);
            setMobileno(response.data.mobile_no);
            setdeliverycontact(response.data.mobile_no);
            setEmailid(response.data.email_id);
            setAddress(response.data.address);
            setdeliveryaddress(response.data.address);
            setLeadID(response.data.lead_id);
            setareaname(response.data.area_name);
            setarea(response.data.area);
            setAreaID(response.data.area);
            setdeliveryLatitude(response.data.latitude);
            setdeliveryLongitude(response.data.longitude);
          } catch (error) {
            console.error('Error fetching data', error);
          }
        };

        fetchleaddetails();

        axios.get(`${baseURL}/generalSetting/1`)
            .then(response => {
                if (response.data && response.data.data) {
                    setgst_percentage(parseFloat(response.data.data.gst));
                } else {
                    console.error("Unexpected API response structure:", response);
                    setgst_percentage(5);
                }
            })
            .catch(error => {
                console.log("Failed to fetch general settings:", error);
                setgst_percentage(5);
            });

    }, []);

    const [productdata, setProductdata] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [subtotal, setsubtotal] = useState(0);
    const [gst, setGst] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [description, setDescription] = useState('');

    const fetchdata = async () => {
        try {
            const response = await axios.get(`${baseURL}/leadsubscription/product/${leadId}`);
            setProductdata(response.data.data);
            setHasFetched(true);

            const totalAmount = response.data.data.reduce((sum, product) => {
                // Convert product_amount to a number and add it to the sum
                const amount = parseFloat(product.product_amount) || 0; // Ensure it doesn't break on invalid data
                return sum + amount;
            }, 0);
    
            setsubtotal(totalAmount);

            const gstValue = totalAmount * (gst_percentage / 100);
            setGst(gstValue); // Store the GST value

            // Calculate total amount (subtotal + GST)
            const total = totalAmount + gstValue;
            setTotalAmount(total); // Store the total amount

        } catch (error) {
            console.error('Error fetching data', error);
            setHasFetched(true);
        }
    };

    useEffect(() => {
        if (gst_percentage > 0) {
            fetchdata();
        }
    }, [gst_percentage, leadId]);
    
    const formatName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    // paymode dropdown
    const [paymentmode, setPaymode] = useState([]);
    const [transactionId, setTransactionId] = useState('');
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [isVisible, setIsVisible] = useState(false);  
    useEffect(() => {
        const fetchpaymode = async () => {
          try {
            const response = await axios.get(`${baseURL}/paymentmode/getactive`);
            const formatted = response.data.map(item => ({
              value: item.sno,
              label: item.paymentmode_name,
              transaction_id: item.transaction_id,
            }));
            setPaymode(formatted);
          } catch (error) {
            console.error('Error fetching lead types:', error);
          }
        };

        fetchpaymode();
    }, []);

    // payment mode onchange
    const handlePaymentChange = (selectedOption) => {
        setSelectedPayment(selectedOption.value);
        setIsVisible(selectedOption?.transaction_id === 0); // Show field only if transaction_id is 0
    };

    // timeline dropdown
    const [timelineoptions, setTimelineoption] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
            const response = await axios.get(`${baseURL}/package-timeline/active`);
            const formatted = response.data.data.map(item => ({
                value: item.sno,
                label: item.packagetimeline_name,
                days_count: item.days,
                sunday: item.sunday,
                monday: item.monday,
                tuesday: item.tuesday,
                wednesday: item.wednesday,
                thursday: item.thursday,
                friday: item.friday,
                saturday: item.saturday,
                all_days: item.all_days
            }));
            setTimelineoption(formatted);
            } catch (error) {
            console.error('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // timeline onchange
    const [selectedtimeline, setSelectedtimeline] = useState(null);
    const [selectedtimelineopt, setSelectedtimelineopt] = useState(null);
    const handletimelinechange = (selectedOption) => {
        setSelectedtimelineopt(selectedOption);
        setSelectedtimeline(selectedOption.value);
        if (startDate) {
            const selectedTimelineDetails = timelineoptions.find(option => option.value === selectedOption.value);
            if (selectedTimelineDetails) {
                calculateEndDate(selectedTimelineDetails, startDate, holidays);
            }
        }
        if (selectedproduct) {
            fetchPackagePrice(selectedproduct, selectedOption.value);
        }
    };

    // products dropdown
    const [productoptions, setProductoption] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
          try {
            const response = await axios.get(`${baseURL}/manage-products/products/active`);
            const formatted = response.data.data.map(item => ({
              value: item.sno,
              label: item.product_name,
            }));
            setProductoption(formatted);
          } catch (error) {
            console.error('Error fetching data', error);
          }
        };

        fetchdata();
    }, []);

    // product onchange
    const [selectedproduct, setSelectedProduct] = useState(null);
    const [selectedproductopt, setSelectedProductopt] = useState(null);
    const handleprodchange = (selectedOption) => {
        setSelectedProductopt(selectedOption);
        setSelectedProduct(selectedOption.value);
        if (selectedtimeline) {
            fetchPackagePrice(selectedOption.value, selectedtimeline);
        }
    };

    // Package price
    const [price, setPrice] = useState(0);
    const [packageID, setPackageID] = useState(null);
    const fetchPackagePrice = async (productId, timelineId) => {
        try {
            const response = await axios.get(`${baseURL}/leadsubscription/package`, {
                params: {
                    products_id: productId,
                    products_timeline: timelineId
                }
            });
    
            if (response.data && response.data.data && response.data.data.selling_amount) {
                setPrice(response.data.data.selling_amount);
                setPackageID(response.data.data.sno);
            } else {
                setPrice(0); // No data, default to 0
            }
        } catch (error) {
            console.error("Error fetching package price:", error);
            setPrice(0); // Error or no data, set price to 0
        }
    };
    
    // start date
    const [startDate, setStartDate] = useState(null);
    const [startDateopt, setStartDateopt] = useState(null);
    const handleStartDateChange = (date) => {
        setStartDateopt(date);
        if (date) {
            const formattedDate = date.format('YYYY-MM-DD');
            console.log(formattedDate);
            setStartDate(formattedDate);
            if (selectedtimeline) {
                const selectedTimelineDetails = timelineoptions.find(option => option.value === selectedtimeline);
                if (selectedTimelineDetails) {
                    calculateEndDate(selectedTimelineDetails, formattedDate, holidays);
                }
            }
        } else {
            setStartDate(null);
        }
    };


    const [city, setCity] = useState('');
    const [couponcode, setCouponcode] = useState('');

    // area dropdown
    const [areaOption, setAreaOption] = useState([]);
    const [selectedArea, setSelectedArea] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/area`);
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.area_name,
                }));
                setAreaOption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);
    
    // delivery point dropdown
    const [dppoption, setdpoption] = useState([]);
    const [dp, setDp] = useState(null);
    const [selecteddp, setselecteddp] = useState(null);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/deliverypoint`);
                const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.delivery_point,
                }));
                setdpoption(formattedsource);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    // dp on change
    const getarea = async (id) => {
        try {
            const response = await axios.get(`${baseURL}/dropdown/dparea/${id}`);
            const formattedsource = response.data.data.map(item => ({
                value: item.sno,
                label: item.name,
            }));
            setAreaOption(formattedsource);
        } catch (error) {
            console.error('Error fetching data', error);
            setHasFetched(true);
        }
    };

    const onchangedeliverypoint = (e) => {
        setDp(e.value);
        setselecteddp(e);
        getarea(e.value);
        setSelectedArea(null);
    }

    // Holiday array
    const [holidays, setHolidays] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/getholiday`);
                setHolidays(response.data.data);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // end date calculation
    const [endDate, setEndDate] = useState(null);

    const calculateEndDate = (timeline, startDate, holidays = []) => {
        const all_days = timeline.all_days;
        const days_count = timeline.days_count;
        let sunday, monday, tuesday, wednesday, thursday, friday, saturday;
        if ( all_days === 1) {
            sunday = timeline.sunday;
            monday = timeline.monday;
            tuesday = timeline.tuesday;
            wednesday = timeline.wednesday;
            thursday = timeline.thursday;
            friday = timeline.friday;
            saturday = timeline.saturday;
        } else {
            sunday = '0';
            monday = '0';
            tuesday = '0';
            wednesday = '0';
            thursday = '0';
            friday = '0';
            saturday = '0';
        }

        // Create a days array that represents the days of the week (0 = Sunday, 6 = Saturday)
        const daysOfWeek = [sunday, monday, tuesday, wednesday, thursday, friday, saturday];
        // console.log(daysOfWeek);
    
        let currentDate = moment(startDate);
        let validDaysCount = 0;
        // console.log(currentDate);
        // Loop until we've counted the required days (excluding invalid ones like Sundays)
        while (validDaysCount < days_count) {
            // console.log(validDaysCount, days_count);

            // Check if the current day is valid to count (i.e., its value is 1)
            const currentDayOfWeek = currentDate.day();

            const currentDateStr = currentDate.format('YYYY-MM-DD');

            const isHoliday = holidays.includes(currentDateStr);
            const isValidDay = daysOfWeek[currentDayOfWeek] === '0';
            // console.log(currentDateStr, isHoliday, isValidDay);

            if (isValidDay && !isHoliday) {
                validDaysCount++;
            }
            
            // if (daysOfWeek[currentDayOfWeek] === '0') {
            //     validDaysCount++;
            // }
    
            // Move to the next day
            currentDate.add(1, 'days');
        }
        const endDate = currentDate.format('YYYY-MM-DD');
        setEndDate(endDate);
    };

    const [modalType, setModalType] = useState("");
    const [open, setOpen] = useState(false);
    const tableRef = useRef(null);

    useEffect(() => {
        if (hasFetched) {
            if (tableRef.current) {
                if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                    $(tableRef.current).DataTable({
                        "responsive": true,
                        //   "aaSorting": [],
                        "ordering": false,
                        "paging": false,
                        "language": {
                            "lengthMenu": "Show _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            // "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            // "<'col-sm-12 d-flex align-items-center justify-content-end mb-2'f>" +
                            // ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-12 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            }
        }
    }, [hasFetched]);

    // product count
    const orderBlog = [
        { id: 1, number: 1 },
    ];
    const reducer = (previousState, updatedState) => ({
        ...previousState,
        ...updatedState,
    });
    const [selectedNumber, setSelectedNumber] = useState(1);
    const [state, setState] = useReducer(reducer, { orderBlog: orderBlog });
    const handleCountAdd = (id) => {
        let temp = state.orderBlog.map((data) => {
            if (id === data.id) {
                const newNumber = data.number + 1;
                setSelectedNumber(newNumber); // update selected number
                return { ...data, number: newNumber };
            }
            return data;
        });
        setState({ orderBlog: temp });
    };
    const handleCountMinus = (id) => {
        let temp = state.orderBlog.map((data) => {
            if (id === data.id) {
                const newNumber = data.number > 1 ? data.number - 1 : data.number;
                setSelectedNumber(newNumber); // update selected number
                return { ...data, number: newNumber };
            }
            return data;
        });
        setState({ orderBlog: temp });
    };

    const [selectedId, setSelecctedID] = useState("");
    const Change_product_details = (selectedId) => {
        setSelecctedID(selectedId);
        setModalType("ChangeProductDetails");
        setOpen(true);
    };

    // delete product
    
    const DeleteModal = (data) => {
        swal.fire({
            html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose one Product
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <p class="text-center"><b>${data.product_name} - ${data.timeline_name}( ${data.timeline_days} Days )</b></p>
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                <defs>
                                    <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#5987dd"/>
                                        <stop offset=".118" stop-color="#638bd6"/>
                                        <stop offset=".316" stop-color="#7d98c3"/>
                                        <stop offset=".572" stop-color="#a8aba3"/>
                                        <stop offset=".871" stop-color="#e3c678"/>
                                        <stop offset="1" stop-color="#ffd364"/>
                                    </radialGradient>
                                    <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                                </defs>
                                <g id="_27-feel_bad" data-name="27-feel bad">
                                    <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                    <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                    <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                    <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="34" cy="22" r="1"/>
                                    <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="16" cy="22" r="1"/>
                                    <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                    <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                    <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                    <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                    <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                    <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                    <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                    <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                    <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                    <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                    <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                                </g>
                            </svg>
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
          if (result.isConfirmed) {
            axios.delete(`${baseURL}/leadsubscription/${data.sno}`)
                .then((result) => {
                    // window.location.reload();
                    softRefresh();
                });
          }
        });
    };

    // delete all
    const DeleteAllModal = (productdata) => {
        swal.fire({
            html: `
                        <div class="alert alert-danger px-2 py-2" role="alert">
                            <strong>OOPS! </strong> You're about to lose all Product
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                        ${productdata.map(data => `
                            <p class="text-center" key=${data.sno}>
                                <b>${data.product_name} - ${data.timeline_days} Days</b>
                            </p>
                        `).join('')}
                        <div class="text-center">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                <defs>
                                    <radialGradient id="radial-gradient" cx="-27.957" cy="8.563" r="6" gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)" gradientUnits="userSpaceOnUse">
                                        <stop offset="0" stop-color="#5987dd"/>
                                        <stop offset=".118" stop-color="#638bd6"/>
                                        <stop offset=".316" stop-color="#7d98c3"/>
                                        <stop offset=".572" stop-color="#a8aba3"/>
                                        <stop offset=".871" stop-color="#e3c678"/>
                                        <stop offset="1" stop-color="#ffd364"/>
                                    </radialGradient>
                                    <style>.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}</style>
                                </defs>
                                <g id="_27-feel_bad" data-name="27-feel bad">
                                    <circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                                    <ellipse cx="24" cy="17" rx="18" ry="15" style="fill:url(#radial-gradient)"/>
                                    <path class="cls-3" d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"/>
                                    <ellipse class="cls-4" cx="33" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="33" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="34" cy="22" r="1"/>
                                    <ellipse class="cls-4" cx="15" cy="23" rx="3" ry="4"/>
                                    <ellipse class="cls-5" cx="15" cy="23" rx="2" ry="3"/>
                                    <circle class="cls-6" cx="16" cy="22" r="1"/>
                                    <path class="cls-5" d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"/>
                                    <path class="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z"/>
                                    <path class="cls-5" d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"/>
                                    <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style="fill:#3bc5f6"/>
                                    <path d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z" style="fill:#00a3e1"/>
                                    <path class="cls-3" d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"/>
                                    <ellipse class="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)"/>
                                    <ellipse class="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)"/>
                                    <ellipse class="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)"/>
                                    <ellipse class="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)"/>
                                    <ellipse class="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)"/>
                                </g>
                            </svg>
                        </div>
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-danger',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                // Create an array of delete promises
                const deletePromises = productdata.map(data =>
                    axios.delete(`${baseURL}/leadsubscription/${data.sno}`)
                );

                // Wait for all deletes to complete
                Promise.all(deletePromises)
                .then(() => {
                    softRefresh(); // call once after all deletes done
                })
                .catch(error => {
                    console.error('Error deleting some products:', error);
                });
            }
        });
    };

    const handleClear = () => {
        setSelectedProduct(null);
        setSelectedProductopt(null);
        setSelectedtimeline(null);
        setSelectedtimelineopt(null);
        setStartDate(null);
        setStartDateopt(null);
        setEndDate(null);
        setState({ orderBlog: [{ id: 1, number: 1 }] });
        setPrice(0);
        setselecteddp(null);
        setSelectedArea([]);
        setSelectedNumber(1);
        setpersonName('');
        setdeliverycontact('');
        setdeliveryaddress('');
        setdeliveryLatitude('');
        setdeliveryLongitude('');
    };

    // add product
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        newErrors.valid = true;
        if (!selectedproduct) {
            newErrors.prod = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.prod = "";
        }
        
        if (!selectedtimeline) {
            newErrors.timel = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.timel = "";
        }

        if (!startDate) {
            newErrors.sdate = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.sdate = "";
        }

        if (price == 0) {
            newErrors.price = "No Package Available.";
            newErrors.valid = false;
        } else {
            newErrors.price = "";
        }

        if (!person_name) {
            newErrors.pname = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.pname = "";
        }

        if (!delivery_contact) {
            newErrors.dcontact = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.dcontact = "";
        }

        if (!delivery_address) {
            newErrors.daddrs = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.daddrs = "";
        }

        if (!delivery_latitude) {
            newErrors.lat = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.lat = "";
        }

        if (!delivery_longitude) {
            newErrors.log = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.log = "";
        }

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            if (!validationErrors.valid){
                return;
            }
        }

        const postData = {
            lead: leadId,
            subscriber: ID,
            lead_name: lead_name,
            lead_mobile_no: mobile_no,
            lead_email_id: email_id,
            delivery_person_name: person_name,
            delivery_contact_number: delivery_contact,
            latitude: delivery_latitude,
            longitude: delivery_longitude,
            product: selectedproduct,
            timeline: selectedtimeline,
            package: packageID,
            product_amount: price,
            product_count: selectedNumber,
            start_date: startDate,
            end_date: endDate,
            address: delivery_address,
            delivery_point: dp,
            area: areaID || area,
            created_by: user_id,
        }

        axios.post(`${baseURL}/leadsubscription`, postData)
            .then(response => {
                softRefresh();
                handleClear();
                // window.location.reload();
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
            });
    };

    const duplicate = (id) => {
        axios.post(`${baseURL}/leadsubscription/duplicate/${id}`)
            .then(response => {
                softRefresh();
                handleClear();
                // window.location.reload();
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
            });
    };


    const [showInput, setShowInput] = useState(false);
    const [coupon, setCoupon] = useState('');

    const handleIconClick = () => {
        setShowInput(true);
    };

    const [couponamount, setcouponamount] = useState(0);
    const [couponID, setcouponId] = useState(null);
    const [errorMessage, setErrorMessage] = useState('');
    const handleApplyClick = () => {
        // You can handle the coupon logic here
        if (!coupon) {
            setErrorMessage('Coupon Code is Required.');
            setTimeout(() => setErrorMessage(''), 5000);
            setShowInput(false);
            return;
        }

        const filter = {
            coupon_code: coupon || '',
            coupon_for: 1
        }

        axios.get(`${baseURL}/coupon/code`, {params: filter})
            .then(response => {
                console.log(response);
                if (response.data.data) {
                    let datas = response.data.data;
                    setcouponId(datas.sno);
                    if (datas.coupon_type === 0){
                        console.log(datas.coupon_value);
                        setcouponamount(parseFloat(datas.coupon_value));
                        setTotalAmount(parseFloat(subtotal + gst - parseFloat(datas.coupon_value)));
                    } else if (datas.coupon_type === 1) {
                        let percentage = parseFloat(datas.coupon_value);
                        let val = parseFloat(subtotal * parseFloat(percentage / 100));
                        console.log(val);
                        setcouponamount(val);
                        setTotalAmount(parseFloat(subtotal + gst - val));
                    }
                } else {
                    setcouponamount(0);
                    setShowInput(false);
                    setErrorMessage('Coupon not valid or expired');
                    // Clear error message after 5 seconds
                    setTimeout(() => setErrorMessage(''), 5000);
                    setcouponId(null);
                    
                }
                setShowInput(false);
            })
            .catch(error => {
                setcouponamount(0);
                setShowInput(false);
                console.log('There was an error fetching the data!', error);
                setErrorMessage('Error fetching coupon. Please try again.');
                setTimeout(() => setErrorMessage(''), 5000);
                setcouponId(null);
            });
    };


    // Add Subscription

    const [errorsubs, setErrorsubs] = useState({});
    const validatesubs = () => {
        const newErrors = {};
        newErrors.valid = true;
        if (productdata.length <= 0) {
            newErrors.prod = "Add Products to Subscribe";
            newErrors.valid = false;
        } else {
            newErrors.prod = "";
        }
        
        if (!selectedPayment) {
            newErrors.paymode = "This Field is Required.";
            newErrors.valid = false;
        } else {
            newErrors.paymode = "";
        }
        
        if (isVisible) {
            if (!transactionId){
                newErrors.trans = "This Field is Required.";
                newErrors.valid = false;
            } else {
                newErrors.trans = "";
            }
        }
        return newErrors;
    };

    const ConfirmationModalSinglePackage = (event) => {
        event.preventDefault();
        const validationErrors = validatesubs();
        if (Object.keys(validationErrors).length > 0) {
            setErrorsubs(validationErrors);
            if (!validationErrors.valid){
                return;
            }
        }

        swal.fire({
            html: `
                <div class="alert alert-success px-2 py-2" role="alert">
                    Are you sure you want to create a subscription package?
                    <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                </div>

                <div class="row mb-2 text-center">
                    <label class="text-black"><b>${lead_name} - ${mobile_no}</b></label>
                </div>

                <div class="row mt-3">
                    <label class='col-lg-12 d-flex justify-content-start text-black font-w400 fs-6 mb-4'>
                        <span class='text-danger font-w500'>Product Details</span>
                    </label>
                    <div class='col-lg-12 text-black font-w400 fs-7 mb-1'>
                        ${productdata.map(data => `
                            <div class="row">
                                <div class="col-lg-9 d-flex justify-content-start">
                                    <span class='text-primary font-w500'>${data.product_name}</span> &nbsp;
                                    <span>(${data.timeline_name} ${data.timeline_days})</span>
                                </div>
                                <div class="text-black fw-semibold fs-7 col-lg-3">
                                    <i class="fa-solid fa-indian-rupee-sign me-2"></i>${data.product_amount}
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                <hr>
                <div class="row mb-2 mt-3">
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-5">Sub Total</div>
                            <div class="text-black fw-semibold fs-4">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${subtotal}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-6">
                                <label class="mb-0">Discount</label>
                                <span class="text-danger fw-bold ms-1"></span>
                            </div>
                            <div class="text-black fw-semibold fs-5">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${couponamount ? couponamount : 0}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <div class="text-black fw-semibold fs-6">
                                <label class="mb-0">GST</label>
                                <span class="text-danger fw-bold ms-1">(${gst_percentage}%)</span>
                            </div>
                            <div class="text-black fw-semibold fs-5">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${gst}
                            </div>
                        </div>
                        <div class="col-lg-12 d-flex justify-content-between mb-2">
                            <label class="text-black fw-semibold fs-4">Total Amount</label>
                            <div class="text-danger fw-bold fs-3">
                                <i class="fa-solid fa-indian-rupee-sign me-2"></i>${totalAmount}
                            </div>
                        </div>
                </div> 
                    `,
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubmitSubscription();
            }
        });
    };

    const handleSubmitSubscription = () => {
        const productsnoList = productdata.map(item => item.sno).join(',');
        const totalScore = productdata.reduce((sum, item) => {
            const score = item.timelinerelation?.score || 0; // use 0 if undefined/null
            return sum + score;
        }, 0);

        const postData = {
            lead: leadId,
            products: productsnoList,
            payment_mode: selectedPayment,
            transaction_id: transactionId,
            sub_total: subtotal,
            gst: gst,
            total_amount: totalAmount,
            coupon_amount: couponamount,
            coupon_id: couponID,
            description: description,
            score: totalScore,
            created_by: user_id,
        }
        axios.post(`${baseURL}/subscription`, postData)
            .then(response => {
                // window.location.href = './manage-subscriptions';
                navigate('/manage-subscriptions', {
                    state: { toastMessage: 'Subscription Created Successfully!', toastType: 'success' }
                });
            })
            .catch(error => {
                console.log('There was an error posting the data!', error);
                navigate('/manage-subscribers', {
                    state: { toastMessage: 'Error Creating Subscription', toastType: 'error' }
                });
            });
    };

    // soft refresh page
    const softRefresh = () => {
        setHasFetched(false);
        if ($.fn.dataTable.isDataTable(tableRef.current)) {
            $(tableRef.current).DataTable().destroy();
        }
        fetchdata();
    }

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };


    return (
        <>
            {/* breadcrumb */}
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Add Subscription</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Subscription Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-order'>Manage Order</Link></li>
                    </ol>
                </div>
            </div>

            {/* models */}
            <>
                {open && modalType === "ChangeProductDetails" && (
                    <ChangeProductDetails show={open} onClose={() => setOpen(false)} selectedId={selectedId} refresh={softRefresh} name={lead_name} mobile={mobile_no} email={email_id} />
                )}
            </>

            {/* subscriber details  */}
            <div className='row mb-2'>
                <div className="col-lg-6">
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Subscriber</label>
                            <label className='text-primary fs-2 font-w500'>{lead_name}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Mobile No</label>
                            <label className='text-primary fs-2 font-w500'>{mobile_no}</label>
                        </div>
                    </div>
                </div>
                <div className='col-lg-6'>
                    <div className='row'>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Email ID</label>
                            <label className='text-black fs-6 font-w500'>{email_id ? email_id : '-'}</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Area</label>
                            <label className='text-black fs-6 font-w500'>{area_name}</label>
                        </div>
                        <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                            <label className='text-gray-800 font-w500 fs-7'>Address</label>
                            <label className='text-black fs-6 font-w500'>{address ? address : '-'}</label>
                        </div>
                    </div>
                </div>
            </div>

            <div className='row'>
                {/* product details */}
                <div className='col-lg-4'>
                    <div className='text-center mb-3'>
                        <div className="text-danger font-w600 fs-3 mt-3">
                            <label className='mb-0'>Product Details</label>
                        </div>
                    </div>
                    <div className='mb-3' style={{ boxShadow: 'rgba(0, 0, 0, 0.2) 0px 0px 0px 0px, rgba(0, 0, 0, 0.19) 0px 0px 6px 0px',}}>
                        <div className='row px-3 py-4'>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Product<span className="required">*</span></label>
                                <Select placeholder='Select Product'
                                    value={selectedproductopt}
                                    onChange={handleprodchange}
                                    options={productoptions}
                                />
                                {errors.prod && <div className="text-danger fs-8 mt-1">{errors.prod}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Timeline<span className="required">*</span></label>
                                <Select placeholder='Select Timeline'
                                    value={selectedtimelineopt}
                                    onChange={handletimelinechange}
                                    options={timelineoptions}
                                />
                                {errors.timel && <div className="text-danger fs-8 mt-1">{errors.timel}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">Start Date<span className="required">*</span></label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        minDate={addDays(new Date(), 1)} // Only allow dates from tomorrow onward
                                        format="DD-MM-YYYY"
                                        value={startDateopt}
                                        onChange={handleStartDateChange}
                                    />
                                </div>
                                {errors.sdate && <div className="text-danger fs-8 mt-1">{errors.sdate}</div>}
                            </div>
                            <div className="col-lg-6 mb-3">
                                <label className="text-black font-w500 fs-7">End Date</label>
                                <div className='datepicker-wrapper d-flex'>
                                    <div className=' input-group-text border-0 px-0 bg-gray-200 rounded-bottom-end-0 rounded-top-end-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                                    <DatePicker placeholder='Select Date'
                                        value={endDate && moment(endDate).format('DD-MM-YYYY')}
                                        format="DD-MM-YYYY"
                                        disabled
                                    />
                                </div>
                            </div>
                            <div className='col-lg-6 mb-3'>
                                <label className="text-black font-w500 fs-7">Delivery Point</label>
                                <Select placeholder="Select Delivery Point"
                                    options={dppoption}
                                    value={selecteddp}
                                    onChange={(e) => {
                                        onchangedeliverypoint(e);
                                    }}
                                />
                                {errors.dpoint && <div className="text-danger fs-8 mt-1">{errors.dpoint}</div>}
                            </div>
                            <div className='col-lg-6 mb-3'>
                                <label className="text-black font-w500 fs-7">Area</label>
                                <Select placeholder="Select Area"
                                    options={areaOption}
                                    value={selectedArea}
                                    onChange={(e) => {
                                        setAreaID(e.value);
                                        setCity(e.value);
                                        setSelectedArea(e);
                                    }}
                                />
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Delivery Person<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Delivery Person" 
                                    maxLength={100}
                                    value={person_name}
                                    onChange={(e) => {
                                        const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                        setpersonName(onlyAlphabets);
                                    }}
                                />
                                {errors.pname && <div className="text-danger fs-8 mt-1">{errors.pname}</div>}
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Mobile Number<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Mobile Number" 
                                    maxLength={10}
                                    value={delivery_contact} 
                                    onChange={(e) => {
                                        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                        setdeliverycontact(onlyNums);
                                    }}
                                />
                                {errors.dcontact && <div className="text-danger fs-8 mt-1">{errors.dcontact}</div>}
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Latitude<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Latitude" 
                                    maxLength={100}
                                    value={delivery_latitude}
                                    onChange={(e) => {
                                        setdeliveryLatitude(e.target.value);
                                    }}
                                />
                                {errors.lat && <div className="text-danger fs-8 mt-1">{errors.lat}</div>}
                            </div>
                            <div className="col-lg-6 mb-4">
                                <label className="text-black font-w500 fs-7">Longitude<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Longitude" 
                                    maxLength={10}
                                    value={delivery_longitude}
                                    onChange={(e) => {
                                        setdeliveryLongitude(e.target.value);
                                    }}
                                />
                                {errors.log && <div className="text-danger fs-8 mt-1">{errors.log}</div>}
                            </div>
                            <div className="col-lg-12 mb-4">
                                <label className="text-black font-w500 fs-7">Delivery Address<span className="required">*</span></label>
                                <textarea className="form-control h-auto" row={'3'} placeholder="Enter Delivery Address" 
                                    maxLength={250}
                                    value={delivery_address} 
                                    onChange={(e) => setdeliveryaddress(formatName(e.target.value))} 
                                />
                                {errors.daddrs && <div className="text-danger fs-8 mt-1">{errors.daddrs}</div>}
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-lg-6 mb-3 text-center">
                                <label className="text-black font-w500 fs-6">Amount</label>
                                <div className='mt-2'>
                                    <label className="text-danger font-w600 fs-5">
                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                        <span>{price}</span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-lg-6 mb-3 text-center">
                                <label className="text-black font-w500 fs-7 mb-2">Product Count<span className="required">*</span></label>
                                {state.orderBlog.map((item, index) => (
                                    <div className="" key={index}>
                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="quntity">
                                                <button data-decrease onClick={() => handleCountMinus(item.id)}>-</button>
                                                <input data-value type="text" value={item.number} readOnly />
                                                <button data-increase onClick={() => handleCountAdd(item.id)}>+</button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="col-lg-12 d-flex align-items-center justify-content-center gap-3 mb-3">
                                <Link onClick={handleSubmit} className="btn btn-sm btn-primary mb-2">Add Product</Link>
                                <Link onClick={handleClear} className="btn btn-sm btn-secondary mb-2">Clear</Link>
                            </div>
                            <span className='text-danger text-center'>{errorsubs.prod}</span>
                        </div>
                    </div>
                </div>

                {/* Plan Details & Transaction Details */}
                <div className='col-lg-8'>
                    
                    {productdata.length>0 ? (
                        <>
                            <div className='text-center mb-3'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Plan Details</label>
                                </div>
                            </div>

                            {/* Show Clear All only if more than 1 product */}
                            {productdata.length > 1 && (
                                <div className='text-end mb-1 pb-1 pe-2' onClick={() => DeleteAllModal(productdata)} style={{ cursor: 'pointer'}}>
                                        <Badge bg="none" className='fs-7 px-2 py-1 border border-info text-info'>Clear All</Badge>
                                </div>
                            )}

                            <div className='row mh-450px scroll-y'>
                                <>
                                    {productdata.map((data, index) => (
                                        <div className='p-3 mb-3 border border-warning bg-warning-light '>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : idly} className='rounded px-1 py-0'>
                                                        <img src={(imgBaseUrl && data.product_image) ? imgBaseUrl + '/' + data.product_image : idly} alt={data.product_name} className='cursor-pointer w-100px h-90px' />
                                                    </div>
                                                </LightGallery>
                                                <div className='row'>
                                                    <label className='text-black font-w400 fs-5'>
                                                        <span className='text-primary font-w500'>{data.product_name}</span>
                                                        <span > ( {data.timeline_name} {data.timeline_days} days ) </span>
                                                    </label>
                                                    <label className='d-block text-black  font-w500 fs-6'>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Date</span></Tooltip>} >
                                                            <i className='fa-solid fa-calendar-days  text-black  fs-6 me-2'></i>
                                                        </OverlayTrigger>
                                                        <span>{data.start_date}</span>
                                                        <span> to </span>
                                                        <span>{data.end_date}</span>
                                                    </label>
                                                    <label className='d-block text-gray-800  font-w500 fs-7'>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Area</span></Tooltip>} >
                                                            <i className="fas fa-map-marker-alt  text-black fs-7 me-2"></i>
                                                        </OverlayTrigger>
                                                        <span className='me-4'>{data.area_name}</span>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delivery point</span></Tooltip>} >
                                                            <i className="fas fa-crosshairs  text-black   fs-7 me-2"></i>
                                                        </OverlayTrigger>
                                                        <span>{data.deliverypoint_name}</span>

                                                    </label>
                                                    <label>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Address</span></Tooltip>} >
                                                            <i className="fas fa-map-pin text-black fs-7 me-2"></i>
                                                        </OverlayTrigger>
                                                        <span>{data.address ? data.address : '-'}</span>
                                                    </label>
                                                </div>
                                                <div className='row mb-3'>
                                                    <label className="d-block text-danger font-w600 fs-5">
                                                        <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                        <span>{data.product_amount}</span>
                                                    </label>
                                                    <label className="d-flex me-3 text-end">
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Edit</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1" onClick={() => Change_product_details(data.sno)}>
                                                                <span><i className="fa-solid fa-pen-to-square fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                        <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Delete</span></Tooltip>} >
                                                            <Button variant="primary tp-btn-light px-2 py-1" onClick={() => DeleteModal(data)}>
                                                                <span><i className="fa-solid fa-trash-can fs-6 mt-1"></i></span>
                                                            </Button>
                                                        </OverlayTrigger>
                                                    </label>

                                                    <div className='d-block'>
                                                        {state.orderBlog.map((item, index) => (
                                                            <div className="" key={index}>
                                                                <div className="d-flex align-items-center justify-content-lg-between">
                                                                    <div className="quntity">
                                                                        <button data-decrease onClick={() => handleCountMinus(item.id)}>-</button>
                                                                        <input data-value type="text" value={item.number} readOnly/>
                                                                        <button data-increase onClick={() => duplicate(data.sno)}>+</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            </div>
                        </>
                    ):(
                        <>
                            <div className='text-center mb-3'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Plan Details</label>
                                </div>
                            </div>

                            <div className='card border border-warning text-center h-300px d-flex justify-content-center align-items-center'>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48" height="48">
                                    <defs>
                                        <radialGradient
                                            id="radial-gradient"
                                            cx="-27.957"
                                            cy="8.563"
                                            r="6"
                                            gradientTransform="matrix(3 0 0 2.5 107.871 -4.408)"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop offset="0" stopColor="#5987dd" />
                                            <stop offset=".118" stopColor="#638bd6" />
                                            <stop offset=".316" stopColor="#7d98c3" />
                                            <stop offset=".572" stopColor="#a8aba3" />
                                            <stop offset=".871" stopColor="#e3c678" />
                                            <stop offset="1" stopColor="#ffd364" />
                                        </radialGradient>
                                        <style>
                                            {`.cls-3{fill:#ffb32b}.cls-4{fill:#273941}.cls-5{fill:#141e21}.cls-6{fill:#f6fafd}`}
                                        </style>
                                    </defs>
                                    <g id="_27-feel_bad" data-name="27-feel bad">
                                        <circle cx="24" cy="24" r="23" style={{ fill: "#ffce52" }} />
                                        <ellipse cx="24" cy="17" rx="18" ry="15" style={{ fill: "url(#radial-gradient)" }} />
                                        <path
                                            className="cls-3"
                                            d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z"
                                        />
                                        <ellipse className="cls-4" cx="33" cy="23" rx="3" ry="4" />
                                        <ellipse className="cls-5" cx="33" cy="23" rx="2" ry="3" />
                                        <circle className="cls-6" cx="34" cy="22" r="1" />
                                        <ellipse className="cls-4" cx="15" cy="23" rx="3" ry="4" />
                                        <ellipse className="cls-5" cx="15" cy="23" rx="2" ry="3" />
                                        <circle className="cls-6" cx="16" cy="22" r="1" />
                                        <path
                                            className="cls-5"
                                            d="M10 19v-2c3.722 0 6-1.295 6-2h2c0 2.626-4.024 4-8 4zM38 19c-3.976 0-8-1.374-8-4h2c0 .705 2.278 2 6 2z"
                                        />
                                        <path className="cls-4" d="M24 35h-5.5a5.265 5.265 0 0 1 5.5-5 5.265 5.265 0 0 1 5.5 5z" />
                                        <path
                                            className="cls-5"
                                            d="M24 31a5.4 5.4 0 0 1 5.39 4h.11a5.265 5.265 0 0 0-5.5-5 5.265 5.265 0 0 0-5.5 5h.11A5.4 5.4 0 0 1 24 31z"
                                        />
                                        <path d="M47 12a4 4 0 0 1-8 0c0-2.209 3-8 4-8s4 5.791 4 8z" style={{ fill: "#3bc5f6" }} />
                                        <path
                                            d="M43 4c-1 0-4 5.791-4 8a4 4 0 0 0 8 0c0-2.209-3-8-4-8zm0 8.5a2.848 2.848 0 0 1-3-2.667C40 8.361 42.25 4.5 43 4.5s3 3.861 3 5.333a2.848 2.848 0 0 1-3 2.667z"
                                            style={{ fill: "#00a3e1" }}
                                        />
                                        <path
                                            className="cls-3"
                                            d="M43 16a3.991 3.991 0 0 1-3.861-3.008A4.661 4.661 0 0 0 39 14a4 4 0 0 0 6.846 2.807q-.255-.777-.562-1.529A3.982 3.982 0 0 1 43 16z"
                                        />
                                        <ellipse className="cls-6" cx="44" cy="11" rx=".825" ry="1.148" transform="rotate(-45.02 44 11)" />
                                        <ellipse className="cls-6" cx="44.746" cy="9.5" rx=".413" ry=".574" transform="rotate(-45.02 44.746 9.5)" />
                                        <ellipse className="cls-6" cx="36" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 36 9)" />
                                        <ellipse className="cls-6" cx="29.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 29.746 4.5)" />
                                        <ellipse className="cls-6" cx="33" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 33 7)" />
                                    </g>
                                </svg>

                                <label className="text-info font-w600 fs-1 ms-1">No Plan Details</label>
                            </div>

                        </>
                    )}

                    {/* transaction details */}
                    <div className='row mb-4'>
                        <div className='col-lg-7'>
                            <div className='text-center mb-4'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Transaction Details</label>
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-lg-6 mb-4'>
                                    <label className="text-black font-w500 fs-7">Payment Mode<span className="required">*</span></label>
                                    <Select
                                        placeholder="Select Mode"
                                        options={paymentmode}
                                        menuPlacement='top'
                                        onChange={handlePaymentChange}
                                    />
                                    <span className='text-danger'>{errorsubs.paymode}</span>
                                </div>
                                {isVisible && (
                                    <div className="col-lg-6 mb-4">
                                        <label className="text-black font-w500 fs-7">Transaction ID<span className="required">*</span>
                                        </label>
                                        <input type="text" className="form-control" placeholder="Enter Transaction ID" 
                                            maxLength={500}
                                            value={transactionId} 
                                            onChange={(e) => setTransactionId(e.target.value)}
                                        />
                                        <span className='text-danger'>{errorsubs.trans}</span>
                                    </div>
                                )}
                                <div className="col-lg-12 mb-4">
                                    <label className="text-black font-w500 fs-7">Description</label>
                                    <textarea className="form-control" placeholder="Enter Description" 
                                        maxLength={250}
                                        value={description} 
                                        onChange={(e) => setDescription(formatName(e.target.value))} 
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-5'>
                            <div className='text-center mb-4'>
                                <div className="text-danger font-w600 fs-3 mt-3">
                                    <label className='mb-0'>Payments Details</label>
                                </div>
                            </div>
                            <div className='row mb-2'>
                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <div className='text-black font-w500 fs-4'>Sub Total</div>
                                    <div>
                                        <label className='text-black font-w500 fs-3'>
                                            <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span>{subtotal}</span>
                                        </label>
                                    </div>
                                </div>
                                
                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <div className='text-black font-w500 fs-5 d-flex align-items-center'>
                                        {!showInput ? (
                                            <>
                                                <label className='text-black font-w500 fs-5'>
                                                    <span>Discount</span>
                                                </label>
                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Apply Coupon</span></Tooltip>} >
                                                    <span onClick={handleIconClick} className='ms-3' style={{ cursor: 'pointer' }}>
                                                        {/* <svg
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="26"
                                                            height="26"
                                                            stroke="#5abf73"
                                                        >
                                                            <path d="M9 15L15 9" stroke="#5abf73" strokeWidth="1.5" strokeLinecap="round" />
                                                            <path d="M15.5 14.5C15.5 15.0523 15.0523 15.5 14.5 15.5C13.9477 15.5 13.5 15.0523 13.5 14.5C13.5 13.9477 13.9477 13.5 14.5 13.5C15.0523 13.5 15.5 13.9477 15.5 14.5Z" fill="#5abf73" />
                                                            <path d="M10.5 9.5C10.5 10.0523 10.0523 10.5 9.5 10.5C8.94772 10.5 8.5 10.0523 8.5 9.5C8.5 8.94772 8.94772 8.5 9.5 8.5C10.0523 8.5 10.5 8.94772 10.5 9.5Z" fill="#5abf73" />
                                                            <path
                                                                d="M14.0037 4H9.9963C6.21809 4 4.32899 4 3.15525 5.17157C2.27661 6.04858 2.0557 7.32572 2.00016 9.49444C1.99304 9.77248 2.22121 9.99467 2.49076 10.0652C3.35074 10.2901 3.98521 11.0711 3.98521 12C3.98521 12.9289 3.35074 13.7099 2.49076 13.9348C2.22121 14.0053 1.99304 14.2275 2.00016 14.5056C2.0557 16.6743 2.27661 17.9514 3.15525 18.8284M18 4.10041C19.3086 4.22774 20.1885 4.51654 20.8448 5.17157C21.7234 6.04858 21.9443 7.32572 21.9998 9.49444C22.007 9.77248 21.7788 9.99467 21.5092 10.0652C20.6493 10.2901 20.0148 11.0711 20.0148 12C20.0148 12.9289 20.6493 13.7099 21.5092 13.9348C21.7788 14.0053 22.007 14.2275 21.9998 14.5056C21.9443 16.6743 21.7234 17.9514 20.8448 18.8284C19.671 20 17.7819 20 14.0037 20H9.9963C8.82865 20 7.84143 20 7 19.9654"
                                                                stroke="#5abf73"
                                                                strokeWidth="1.5"
                                                                strokeLinecap="round"
                                                            />
                                                        </svg> */}
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            height="50"
                                                            id="coupon"
                                                            enableBackground="new 0 0 512 512"
                                                            viewBox="0 0 512 512"
                                                        >
                                                            <path
                                                                fill="#ff4646"
                                                                d="M400,368H48c0-17.673-14.327-32-32-32V112c17.673,0,32-14.327,32-32h352c0,17.673,14.327,32,32,32v224
			C414.327,336,400,350.327,400,368z"
                                                            />
                                                            <path
                                                                fill="#a5c3dc"
                                                                d="M200,328H88c-8.837,0-16-7.163-16-16V200h144v112C216,320.837,208.837,328,200,328z"
                                                            />
                                                            <path
                                                                fill="#e6e6eb"
                                                                d="M120,328H72c-8.837,0-16-7.163-16-16V200h80v112C136,320.837,128.837,328,120,328z"
                                                            />
                                                            <rect width="40" height="16" x="56" y="200" fill="#a5c3dc" />
                                                            <path
                                                                fill="#a5c3dc"
                                                                d="M48,160h176c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
				C40,163.582,43.582,160,48,160z"
                                                            />
                                                            <path
                                                                fill="#e6e6eb"
                                                                d="M48,160h88c4.418,0,8,3.582,8,8v24c0,4.418-3.582,8-8,8H48c-4.418,0-8-3.582-8-8v-24
				C40,163.582,43.582,160,48,160z"
                                                            />
                                                            <rect width="16" height="128" x="88" y="200" fill="#463c4b" />
                                                            <rect width="16" height="16" x="88" y="200" fill="#32283c" />
                                                            <rect width="16" height="40" x="80" y="160" fill="#463c4b" />
                                                            <rect width="16" height="40" x="176" y="160" fill="#32283c" />
                                                            <rect width="16" height="128" x="168" y="200" fill="#32283c" />
                                                            <path
                                                                fill="#32283c"
                                                                d="M196,104c-15.033,0-29.168,5.854-39.8,16.485L136,140.686l-20.201-20.201C105.168,109.854,91.033,104,76,104
			c-15.439,0-28,12.561-28,28s12.561,28,28,28h120c15.439,0,28-12.561,28-28S211.439,104,196,104z M76,144c-6.617,0-12-5.383-12-12
			s5.383-12,12-12c10.76,0,20.877,4.19,28.485,11.799L116.687,144H76z M196,144h-40.687l12.2-12.201
			C175.123,124.19,185.24,120,196,120c6.617,0,12,5.383,12,12S202.617,144,196,144z"
                                                            />
                                                            <g>
                                                                <rect width="16" height="32" x="256" y="112" fill="#e6e6eb" />
                                                                <rect width="16" height="16" x="256" y="80" fill="#e6e6eb" />
                                                                <rect width="16" height="16" x="256" y="352" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="160" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="208" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="256" fill="#e6e6eb" />
                                                                <rect width="16" height="32" x="256" y="304" fill="#e6e6eb" />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M320,200c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S333.233,200,320,200z M320,168
			c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S324.411,168,320,168z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M384,296c-13.233,0-24-10.766-24-24s10.767-24,24-24s24,10.766,24,24S397.233,296,384,296z M384,264
			c-4.411,0-8,3.589-8,8s3.589,8,8,8s8-3.589,8-8S388.411,264,384,264z"
                                                                />
                                                            </g>
                                                            <g>
                                                                <path
                                                                    fill="#e6e6eb"
                                                                    d="M319.994,296.002c-1.203,0-2.423-0.272-3.572-0.846c-3.951-1.976-5.553-6.781-3.577-10.733l64-128
			c1.977-3.952,6.78-5.552,10.733-3.578c3.951,1.976,5.553,6.781,3.577,10.733l-64,128
			C325.754,294.381,322.929,296.002,319.994,296.002z"
                                                                />
                                                            </g>
                                                        </svg>
                                                    </span>
                                                </OverlayTrigger>
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    className='form-control w-125px h-30px me-2'
                                                    placeholder='Enter Coupon'
                                                    value={coupon}
                                                    onChange={(e) => setCoupon(e.target.value)}
                                                />
                                            </>
                                        )}
                                    </div>

                                    <div className='text-black font-w500 fs-4 ms-5 align-items-center d-flex'>
                                        {!showInput ? (
                                            <>
                                            <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                            <label>{couponamount}</label>
                                            </>
                                        ) : (
                                            <button className='btn btn-sm btn-secondary' onClick={handleApplyClick}>
                                                Apply
                                            </button>
                                        )}
                                    </div>
                                </div>

                                {errorMessage && (
                                    <div style={{ color: 'red', marginBottom: '0.5rem'}}>
                                        {errorMessage}
                                    </div>
                                )}

                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <div className='text-black font-w500 fs-5'>
                                        <label className='text-black font-w500 fs-5'>GST</label>
                                        <label className='text-danger font-w600 fs-5 ms-1'>( {gst_percentage}% )</label>
                                    </div>
                                    <div className='text-black font-w500 fs-4'>
                                        <label className='text-black font-w500 fs-4'><i className="fa-solid fa-indian-rupee-sign me-2"></i></label>
                                        <label className='text-black font-w500 fs-4'>{gst}</label>
                                    </div>
                                </div>

                                <div className='col-lg-12 d-flex justify-content-between mb-2'>
                                    <label className='text-black font-w500 fs-3'>Total Amount</label>
                                    <div>
                                        <label className='text-danger fw-bold fs-2'>
                                            <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                            <span>{totalAmount}</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                        <Link to={'/manage-subscribers'} className="btn btn-sm btn-secondary">Cancel</Link>
                        <Link to={'#'} className="btn btn-sm btn-primary" onClick={ConfirmationModalSinglePackage}>Create Subscription</Link>
                    </div>
                </div>
            </div >
        </>
    )

}
export default AddSubscription;